import _ from 'lodash';
import React from "react";
import Favorite from "./Favorite";

export default function ImageStars({ stars, size }) {
  if (!stars) return null;
  return _.fill(Array(stars), <Favorite size={size}/>);
}
